// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { BiArrowBack } from "react-icons/bi";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import { FiSave } from "react-icons/fi";

// const AddSchoolSubjectiveExamPricing = () => {

//   const navigate = useNavigate();
//   const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

//   const [classes, setClasses] = useState([]);
//   const [classId, setClassId] = useState("");
//   const [subjects, setSubjects] = useState([]);
//   const [subjectId, setSubjectId] = useState("");
//   const [price, setPrice] = useState("");
//   const [loadingSubjects, setLoadingSubjects] = useState(false);

//   /* ================= FETCH CLASSES ================= */

//   useEffect(() => {

//     axios.get(`${API_BASE_URL}/classes`)
//       .then(res => setClasses(res.data.data))
//       .catch(err => console.log(err));

//   }, []);


//   /* ================= FETCH SUBJECTS ================= */

//   useEffect(() => {

//     if (!classId) return;

//     setLoadingSubjects(true);

//     axios.get(`${API_BASE_URL}/subjects?reference=${classId}`)
//       .then(res => setSubjects(res.data.data))
//       .catch(err => console.log(err))
//       .finally(() => setLoadingSubjects(false));

//   }, [classId]);


//   /* ================= SUBMIT ================= */

//   const handleSubmit = async (e) => {

//     e.preventDefault();

//     if (!subjectId)
//       return toast.error("Please select subject");

//     try {

//       const payload = {
//         type: "school",
//         classId,
//         subjectId,
//         price
//       };

//       await axios.post(
//         `${API_BASE_URL}/admin/pricing/subjective-exam`,
//         payload,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`
//           }
//         }
//       );

//       toast.success("Price added successfully");

//       setSubjectId("");
//       setPrice("");

//     }
//     catch (err) {

//       toast.error(err?.response?.data?.message || "Error");

//     }

//   };


//   /* ================= UI ================= */

//   return (

//     <div style={styles.page}>

//       {/* HEADER */}

//       <div style={styles.headerWrapper}>

//         <div style={styles.headerLeft}>

//           <BiArrowBack
//             style={styles.backBtn}
//             onClick={() => navigate("/subjective-exam-pricing")}
//           />

//           <div>

//             <div style={styles.title}>
//               Subjective Exam Pricing
//             </div>

//             <div style={styles.subtitle}>
//               Configure pricing for school subjects
//             </div>

//           </div>

//         </div>


//         {/* RIGHT ACTION BUTTONS */}

//         <div style={styles.headerActions}>

//           <button
//             onClick={() =>
//               navigate("/subjective-exam-pricing/add-school-subjective-exam-pricing")
//             }
//             style={styles.addBtn}
//           >
//             + Add Price
//           </button>


//           <button
//             onClick={() =>
//               navigate("/subjective-exam-pricing/all-school-subjective-exam-pricing")
//             }
//             style={styles.allBtn}
//           >
//             All Price
//           </button>

//         </div>

//       </div>



//       {/* CARD */}

//       <div style={styles.card}>

//         <form onSubmit={handleSubmit}>

//           {/* CLASS SELECT */}

//           <div style={styles.field}>

//             <label style={styles.label}>
//               Select Class
//             </label>

//             <select
//               value={classId}
//               onChange={e => {
//                 setClassId(e.target.value);
//                 setSubjectId("");
//               }}
//               style={styles.select}
//               required
//             >
//               <option value="">Choose Class</option>

//               {classes.map(c => (
//                 <option key={c._id} value={c._id}>
//                   {c.className}
//                 </option>
//               ))}

//             </select>

//           </div>


//           {/* SUBJECT SELECT */}

//           <div style={styles.field}>

//             <label style={styles.label}>
//               Select Subject
//             </label>

//             {!classId ? (

//               <div style={styles.placeholder}>
//                 Select class first
//               </div>

//             ) : loadingSubjects ? (

//               <div style={styles.placeholder}>
//                 Loading subjects...
//               </div>

//             ) : (

//               <div style={styles.subjectGrid}>

//                 {subjects.map(subject => {

//                   const selected = subjectId === subject._id;

//                   return (

//                     <div
//                       key={subject._id}
//                       onClick={() => setSubjectId(subject._id)}
//                       style={{
//                         ...styles.subjectCard,
//                         ...(selected && styles.subjectCardSelected)
//                       }}
//                     >

//                       <img
//                         src={`${API_BASE_URL}/uploads/${subject.icon}`}
//                         alt=""
//                         style={styles.subjectIcon}
//                       />

//                       <div style={styles.subjectName}>
//                         {subject.subjectName}
//                       </div>

//                     </div>

//                   );

//                 })}

//               </div>

//             )}

//           </div>


//           {/* PRICE */}

//           <div style={styles.field}>

//             <label style={styles.label}>
//               Price (₹)
//             </label>

//             <input
//               type="number"
//               value={price}
//               onChange={e => setPrice(e.target.value)}
//               placeholder="Enter subject price"
//               style={styles.input}
//               required
//             />

//           </div>


//           {/* BUTTON */}

//           <button style={styles.saveBtn}>

//             <FiSave />
//             Save Pricing

//           </button>

//         </form>

//       </div>

//     </div>

//   );

// };


// /* ================= STYLES ================= */

// const styles = {
//   headerWrapper: {

//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     marginBottom: "25px"

//   },

//   headerActions: {

//     display: "flex",
//     gap: "12px"

//   },

//   addBtn: {

//     padding: "10px 18px",
//     borderRadius: "10px",
//     border: "none",
//     background:
//       "linear-gradient(135deg,#10b981,#059669)",
//     color: "#fff",
//     fontWeight: "600",
//     cursor: "pointer",
//     boxShadow:
//       "0 4px 12px rgba(16,185,129,0.3)"

//   },

//   allBtn: {

//     padding: "10px 18px",
//     borderRadius: "10px",
//     border: "1px solid #6366f1",
//     background: "#fff",
//     color: "#6366f1",
//     fontWeight: "600",
//     cursor: "pointer"

//   },

//   page: {

//     padding: "30px",
//     background:
//       "linear-gradient(135deg,#f6f9ff,#eef2ff)",
//     minHeight: "100vh"

//   },

//   header: {

//     marginBottom: "20px"

//   },

//   headerLeft: {

//     display: "flex",
//     alignItems: "center",
//     gap: "15px"

//   },

//   backBtn: {

//     fontSize: "28px",
//     cursor: "pointer",
//     color: "#6366f1"

//   },

//   title: {

//     fontSize: "24px",
//     fontWeight: "700"

//   },

//   subtitle: {

//     fontSize: "14px",
//     color: "#666"

//   },

//   card: {

//     background: "#fff",
//     padding: "30px",
//     borderRadius: "16px",
//     boxShadow:
//       "0 10px 30px rgba(0,0,0,0.08)"

//   },

//   field: {

//     marginBottom: "25px"

//   },

//   label: {

//     fontWeight: "600",
//     marginBottom: "8px",
//     display: "block"

//   },

//   select: {

//     width: "100%",
//     padding: "12px",
//     borderRadius: "8px",
//     border: "1px solid #ddd",
//     fontSize: "15px"

//   },

//   input: {

//     width: "100%",
//     padding: "12px",
//     borderRadius: "8px",
//     border: "1px solid #ddd",
//     fontSize: "15px"

//   },

//   subjectGrid: {

//     display: "grid",
//     gridTemplateColumns:
//       "repeat(auto-fill,minmax(200px,1fr))",
//     gap: "15px"

//   },

//   subjectCard: {

//     border: "1px solid #eee",
//     padding: "14px",
//     borderRadius: "12px",
//     cursor: "pointer",
//     textAlign: "center",
//     transition: "0.2s",
//     background: "#fafafa"

//   },

//   subjectCardSelected: {

//     border: "2px solid #6366f1",
//     background: "#eef2ff"

//   },

//   subjectIcon: {

//     height: "40px",
//     marginBottom: "6px"

//   },

//   subjectName: {

//     fontWeight: "600",
//     fontSize: "14px"

//   },

//   saveBtn: {

//     display: "flex",
//     alignItems: "center",
//     gap: "8px",
//     padding: "12px 20px",
//     background:
//       "linear-gradient(135deg,#6366f1,#8b5cf6)",
//     border: "none",
//     borderRadius: "10px",
//     color: "#fff",
//     fontWeight: "600",
//     cursor: "pointer"

//   },

//   placeholder: {

//     padding: "15px",
//     background: "#f4f6fb",
//     borderRadius: "10px",
//     color: "#666"

//   }

// };

// export default AddSchoolSubjectiveExamPricing;






























import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

const API = process.env.REACT_APP_API_BASEURL;

export default function SubjectiveExamSubscription() {

  const token = localStorage.getItem("token");

  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);

  const [classId, setClassId] = useState("");
  const [subjectId, setSubjectId] = useState("");

  const [plans, setPlans] = useState([
    { duration: 1, price: "" },
    { duration: 3, price: "" },
    { duration: 6, price: "" },
    { duration: 12, price: "" }
  ]);

  const [trialEnabled, setTrialEnabled] = useState(true);
  const [trialDays, setTrialDays] = useState(7);

  const [existingPlan, setExistingPlan] = useState(null);
  const [loading, setLoading] = useState(false);

  const headers = {
    Authorization: `Bearer ${token}`
  };

  /* ================= FETCH CLASSES ================= */

  useEffect(() => {
    axios.get(`${API}/classes`)
      .then(res => setClasses(res.data.data))
      .catch(console.log);
  }, []);

  /* ================= FETCH SUBJECTS ================= */

  useEffect(() => {

    if (!classId) {
      setSubjects([]);
      return;
    }

    axios.get(`${API}/subjects?reference=${classId}`)
      .then(res => setSubjects(res.data.data))
      .catch(console.log);

  }, [classId]);

  /* ================= FETCH PLAN ================= */

  const fetchPlan = async () => {

    if (!classId || !subjectId) {
      Swal.fire("Missing", "Select class and subject", "warning");
      return;
    }

    setLoading(true);

    try {

      const res = await axios.get(
        `${API}/pricing/subjective-exam?classId=${classId}&subjectId=${subjectId}`,
        { headers }
      );

      const data = res.data.data;

      setExistingPlan(data);

      if (data) {
        setPlans(data.subscriptionOptions);
        setTrialEnabled(data.trialEnabled);
        setTrialDays(data.trialDays);
      }

      Swal.fire({
        icon: "success",
        title: "Plan Loaded",
        timer: 1200,
        showConfirmButton: false
      });

    }
    catch {

      setExistingPlan(null);

      Swal.fire({
        icon: "info",
        title: "No Plan Found",
        text: "Create new subscription plan"
      });

    }
    finally {
      setLoading(false);
    }

  };

  /* ================= HANDLE PRICE ================= */

  const handlePriceChange = (duration, value) => {

    setPlans(prev =>
      prev.map(p =>
        p.duration === duration
          ? { ...p, price: Number(value) }   // 🔥 convert to number
          : p
      )
    );

  };

  /* ================= CREATE ================= */

  const createPlan = async () => {

    try {

      setLoading(true);

      const res = await axios.post(
        `${API}/admin/pricing/subjective-exam`,
        {
          type: "school",
          classId,
          subjectId,
          subscriptionOptions: plans,
          trialEnabled,
          trialDays
        },
        { headers }
      );


      console.log(res);

      Swal.fire({
        icon: "success",
        title: "Created",
        text: res.data.message,
        confirmButtonColor: "#6366f1"
      });

      fetchPlan();

    }
    catch (err) {

      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.response?.data?.message
      });

    }
    finally {
      setLoading(false);
    }

  };

  /* ================= UPDATE ================= */

  const updatePlan = async () => {

    try {

      setLoading(true);

      const res = await axios.put(
        `${API}/admin/pricing/subjective-exam/${existingPlan._id}`,
        {
          subscriptionOptions: plans,
          trialEnabled,
          trialDays
        },
        { headers }
      );

      Swal.fire({
        icon: "success",
        title: "Updated",
        text: res.data.message || "Plan Updated"
      });

      fetchPlan();

    }
    catch (err) {

      Swal.fire("Error", err.response?.data?.message, "error");

    }
    finally {
      setLoading(false);
    }

  };

  /* ================= DELETE ================= */

  const deletePlan = async () => {

    const confirm = await Swal.fire({
      title: "Delete Plan?",
      text: "This action cannot be undone",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ef4444"
    });

    if (!confirm.isConfirmed) return;

    try {

      await axios.delete(
        `${API}/admin/pricing/subjective-exam/${existingPlan._id}`,
        { headers }
      );

      Swal.fire("Deleted", "Plan deleted", "success");

      setExistingPlan(null);
      setPlans([
        { duration: 1, price: "" },
        { duration: 3, price: "" },
        { duration: 6, price: "" },
        { duration: 12, price: "" }
      ]);
      setTrialEnabled(true);
      setTrialDays(7);

    }
    catch (err) {

      Swal.fire("Error", err.response?.data?.message, "error");

    }

  };

  /* ================= UI ================= */

  return (

    <div className="genz-container">

      <h2 className="title">
        🚀 Subject Subscription Manager
      </h2>

      <div className="card">

        <select
          value={classId}
          onChange={e => setClassId(e.target.value)}
          className="input"
        >
          <option>Select Class</option>
          {classes.map(c => (
            <option key={c._id} value={c._id}>
              {c.className}
            </option>
          ))}
        </select>

        <select
          value={subjectId}
          onChange={e => setSubjectId(e.target.value)}
          className="input"
        >
          <option>Select Subject</option>
          {subjects.map(s => (
            <option key={s._id} value={s._id}>
              {s.subjectName}
            </option>
          ))}
        </select>

        <button onClick={fetchPlan} className="btn primary">
          Load Plan
        </button>

      </div>

      <div className="card">

        {plans.map(plan => (

          <div key={plan.duration} className="plan-row">

            <span>{plan.duration} Month</span>

            <input
              type="number"
              value={plan.price}
              placeholder="Enter price"
              onChange={e =>
                handlePriceChange(plan.duration, e.target.value)
              }
              className="input"
            />

          </div>

        ))}

        <div className="plan-row">
          <span>Trial Enabled</span>
          <input
            type="checkbox"
            checked={trialEnabled}
            onChange={e => setTrialEnabled(e.target.checked)}
          />
        </div>

        <div className="plan-row">
          <span>Trial Days</span>
          <input
            type="number"
            value={trialDays}
            onChange={e => setTrialDays(e.target.value)}
            className="input"
          />
        </div>

        {!existingPlan ?

          <button onClick={createPlan} className="btn success">
            Create Plan
          </button>

          :

          <>
            <button onClick={updatePlan} className="btn warning">
              Update Plan
            </button>

            <button onClick={deletePlan} className="btn danger">
              Delete Plan
            </button>
          </>
        }

      </div>

      {/* CSS */}

      <style>{`



      .genz-container{
        max-width:600px;
        margin:40px auto;
        font-family: Inter, -apple-system, BlinkMacSystemFont, sans-serif;
      }


      /* TITLE */

      .title{
        color:#4f46e5; /* strong indigo */
        text-align:center;
        margin-bottom:20px;
        font-weight:600;
      }


      /* CARD */

      .card{
        background: linear-gradient(
          135deg,
          #f5f3ff,
          #ede9fe
        );

        padding: 22px;
        border-radius: 16px;
        margin-bottom: 20px;

        border: 1px solid #e0e7ff;

        box-shadow:
          0 4px 12px rgba(99,102,241,0.08),
          0 2px 4px rgba(0,0,0,0.04);
      }


      /* INPUT */

      .input{
        width:100%;
        padding:12px 14px;

        border-radius:10px;

        border:1px solid #dbeafe;

        background:white;

        color:#111827;

        font-size:14px;

        outline:none;

        transition:0.2s;
      }

      .input:focus{
        border-color:#6366f1;
        box-shadow:0 0 0 3px rgba(99,102,241,0.1);
      }


      /* BUTTON BASE */

      .btn{
        width:100%;
        padding:12px;
        border:none;
        border-radius:12px;
        margin-top:10px;

        cursor:pointer;

        font-weight:600;

        font-size:14px;

        transition:all 0.25s ease;
      }

      .btn:hover{
        transform:translateY(-1px);
        box-shadow:0 6px 14px rgba(0,0,0,0.1);
      }


      /* BUTTON COLORS */

      .primary{
        background:#6366f1;
        color:white;
      }

      .primary:hover{
        background:#4f46e5;
      }


      .success{
        background:#10b981;
        color:white;
      }

      .success:hover{
        background:#059669;
      }


      .warning{
        background:#f59e0b;
        color:white;
      }

      .warning:hover{
        background:#d97706;
      }


      .danger{
        background:#ef4444;
        color:white;
      }

      .danger:hover{
        background:#dc2626;
      }


      /* PLAN ROW */

      .plan-row{

        display:flex;

        justify-content:space-between;

        align-items:center;

        margin-bottom:12px;

        color:#374151; /* FIXED dark text */

        font-weight:500;

      }


      /* LABEL TEXT */

      .plan-row span{
        color:#374151;
      }


      /* CHECKBOX */

      .plan-row input[type="checkbox"]{

        width:18px;
        height:18px;
        accent-color:#6366f1;

      }
      `}</style>

    </div>

  );

}